// import { amgApi } from "@/service/axios";

import axios from "@/axios";

class ColiseumService {
    async saveColiseum(body) {
        const data = await axios.post(`/api/coliseum/save`, body)
        return data;
    }
    async getColiseumsToSelect(body) {
        const data = await axios.post(`/api/coliseum/get-to-select`, body)
        return data;
    }
    
}
export default new ColiseumService()
